import { useDevopsAccess } from '../../hooks/useDevopsAccess';

/**
 * Renders children only when the user belongs to the devops group.
 * Returns null (hidden) while loading or when not allowed.
 */
export function DevopsOnly({ children }: { children: React.ReactNode }) {
  const { allowed, loading } = useDevopsAccess();
  if (loading || !allowed) return null;
  return <>{children}</>;
}
